import { z } from 'zod';

const OrganizationData = z.object({
  id: z.string(),
  name: z.string(),
  registrationNumber: z.string(),
});

const PlanData = z.object({
  tier: z.enum(['premium', 'base']),
});

const Role = z.enum(['owner', 'member']);

const FeatureAccessData = z.object({
  hasAreaAnalysis: z.boolean(),
  hasPropertyAnalysis: z.boolean(),
});

const OrganizationEntry = z.object({
  id: z.string(),
  name: z.string(),
  role: Role,
});

export type OrganizationEntry = z.infer<typeof OrganizationEntry>;

export const UserData = z.object({
  email: z.string(),
  role: Role.optional(),
  organization: OrganizationData.nullable().optional(),
  organizations: z.array(OrganizationEntry).optional(),
  isOnboarded: z.boolean(),
  currentPlan: PlanData.nullable(),
  featureAccess: FeatureAccessData.nullable().optional(),
  userId: z.string().uuid(),
  isSuperuser: z.boolean().optional(),
});

export type FeatureAccess = z.infer<typeof FeatureAccessData>;

export type User = z.infer<typeof UserData>;

export const ChangePasswordParams = z.object({
  newPassword: z
    .string()
    .min(8)
    .regex(/[A-Z]/)
    .regex(/[a-z]/)
    .regex(/[0-9]/)
    .regex(/[!@#$%^&*]/),
});

export const ChangePasswordFormSchema = ChangePasswordParams.extend({
  confirmPassword: z.string(),
}).refine((data) => data.newPassword === data.confirmPassword, {
  message: 'settings:passwordsDoNotMatch',
  path: ['confirmPassword'],
});

export const ChangePasswordResponse = z.object({
  success: z.boolean(),
  error: z.string().optional(),
});

export type ChangePasswordParams = z.infer<typeof ChangePasswordParams>;
export type ChangePasswordResponse = z.infer<typeof ChangePasswordResponse>;

export const UserStatsSchema = z.object({
  hasAreaReports: z.boolean(),
  hasProperties: z.boolean(),
});

export type UserStats = z.infer<typeof UserStatsSchema>;
